import MoreMenuContent from './MoreMenuContent';
import MoreMenuContentContainer from './MoreMenuContent.container';

export default MoreMenuContentContainer(MoreMenuContent);
